"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacingsDefault = void 0;
var spacingsDefault = {
  none: 0,
  s: 4,
  m: 8,
  l: 16,
  xl: 32,
  xxl: 64,
  xxxl: 128
};
exports.spacingsDefault = spacingsDefault;